import styled from "@emotion/styled";

export const HostContainer = styled.div`
  margin-right: 1rem;
  min-width: 0;
`;
